exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-0c44767e]{width:100%}p[data-v-0c44767e]{color:#fff;font-size:15px;text-align:justify}td[data-v-0c44767e]{width:50%}", ""]);

// exports
